var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 15,
    viewBox: "0 0 7 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16105 0.000210762C1.31044 -0.000296593 1.45805 0.0326748 1.59303 0.0967035C1.72801 0.160732 1.84693 0.254191 1.94105 0.370212L6.77105 6.37021C6.91813 6.54914 6.99854 6.77359 6.99854 7.00521C6.99854 7.23684 6.91813 7.46128 6.77105 7.64021L1.77105 13.6402C1.60131 13.8444 1.3574 13.9729 1.09297 13.9972C0.828545 14.0216 0.565264 13.94 0.361047 13.7702C0.156831 13.6005 0.0284066 13.3566 0.00402689 13.0921C-0.0203528 12.8277 0.0613084 12.5644 0.231047 12.3602L4.70105 7.00021L0.381048 1.64021C0.258765 1.49343 0.181087 1.31469 0.157208 1.12514C0.133328 0.935588 0.164245 0.743164 0.246301 0.570636C0.328357 0.398108 0.458117 0.252697 0.620227 0.151607C0.782338 0.0505161 0.970014 -0.00202084 1.16105 0.000210762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ae523c034a7c505402219d8715b6884d.svg";
export { ForwardRef as ReactComponent };